import React, { useState } from 'react';
import { catalogueService } from '../services/catalogueService';

const CatalogueOTPModal = ({ studio, studioName, onClose, onSuccess }) => {
    const [step, setStep] = useState('details'); // 'details' or 'otp'
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const renderIcon = (name, size = 24) => {
        const icons = {
            lock: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>,
            shield: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
            alert: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>,
            check: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>,
            mail: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
            send: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>,
            clock: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
            refresh: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>,
        };
        return icons[name] || null;
    };

    const handleRequestOTP = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await catalogueService.requestOTP(email, studio);
            setSuccess('OTP sent successfully to your email ID.');
            setStep('otp');
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to send OTP. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleVerifyOTP = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await catalogueService.verifyOTP(email, otp, studio);
            onSuccess(response.accessToken, studio, studioName);
        } catch (err) {
            setError(err.response?.data?.message || 'Invalid OTP. Please try again.');
            setLoading(false);
        }
    };

    const handleResendOTP = async () => {
        setError('');
        setLoading(true);
        setOtp('');

        try {
            const response = await catalogueService.requestOTP(email, studio);
            setSuccess(response.message);
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to resend OTP.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.95)',
            backdropFilter: 'blur(10px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
            padding: '20px',
            animation: 'fadeIn 0.3s ease',
            overflowY: 'auto'
        }}>
            <div style={{
                background: 'linear-gradient(135deg, #1a1a1a 0%, #0F0F0F 100%)',
                border: '2px solid rgba(201, 169, 110, 0.3)',
                borderRadius: '20px',
                padding: '35px 30px',
                maxWidth: '500px',
                width: '100%',
                margin: 'auto',
                position: 'relative',
                boxShadow: '0 20px 60px rgba(201, 169, 110, 0.2), 0 0 100px rgba(201, 169, 110, 0.1)',
                animation: 'slideUp 0.4s ease'
            }}>
                {/* Close Button */}
                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '20px',
                        right: '20px',
                        width: '40px',
                        height: '40px',
                        background: 'rgba(201, 169, 110, 0.1)',
                        border: '1px solid rgba(201, 169, 110, 0.3)',
                        borderRadius: '50%',
                        color: 'var(--accent-color)',
                        fontSize: '22px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.3s ease',
                        zIndex: 10
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.background = 'var(--accent-color)';
                        e.target.style.color = '#000';
                        e.target.style.transform = 'rotate(90deg)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.background = 'rgba(201, 169, 110, 0.1)';
                        e.target.style.color = 'var(--accent-color)';
                        e.target.style.transform = 'rotate(0deg)';
                    }}
                >
                    ×
                </button>

                {/* Decorative Icon */}
                <div style={{ 
                    textAlign: 'center', 
                    marginBottom: '15px',
                    color: 'var(--accent-color)',
                    filter: 'drop-shadow(0 0 20px rgba(201, 169, 110, 0.5))'
                }}>
                    {renderIcon('lock', 48)}
                </div>

                {/* Studio Name */}
                <div style={{ textAlign: 'center', marginBottom: '25px' }}>
                    <h2 style={{ 
                        fontSize: '28px', 
                        fontWeight: '300', 
                        color: 'var(--accent-color)',
                        marginBottom: '6px',
                        letterSpacing: '-0.5px'
                    }}>
                        {studioName}
                    </h2>
                    <p style={{ 
                        fontSize: '13px', 
                        color: 'rgba(245, 241, 237, 0.7)',
                        letterSpacing: '1.5px',
                        textTransform: 'uppercase',
                        fontWeight: '500',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px'
                    }}>
                        {renderIcon('shield', 16)} Secure Catalogue Access
                    </p>
                </div>

                {/* Error Message */}
                {error && (
                    <div style={{
                        padding: '12px 16px',
                        background: 'rgba(230, 57, 70, 0.15)',
                        border: '1px solid rgba(230, 57, 70, 0.4)',
                        borderRadius: '10px',
                        color: '#ff6b6b',
                        marginBottom: '18px',
                        fontSize: '13px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        animation: 'shake 0.5s ease'
                    }}>
                        {renderIcon('alert', 20)}
                        <span>{error}</span>
                    </div>
                )}

                {/* Success Message */}
                {success && (
                    <div style={{
                        padding: '12px 16px',
                        background: 'rgba(40, 167, 69, 0.15)',
                        border: '1px solid rgba(40, 167, 69, 0.4)',
                        borderRadius: '10px',
                        color: '#51cf66',
                        marginBottom: '18px',
                        fontSize: '13px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        animation: 'slideDown 0.3s ease'
                    }}>
                        {renderIcon('check', 20)}
                        <span>{success}</span>
                    </div>
                )}

                {/* Details Step */}
                {step === 'details' && (
                    <form onSubmit={handleRequestOTP}>
                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label style={{ 
                                display: 'block', 
                                marginBottom: '6px', 
                                fontSize: '13px', 
                                color: 'rgba(245, 241, 237, 0.9)',
                                fontWeight: '500'
                            }}>
                                Full Name *
                            </label>
                            <input
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                                placeholder="Enter your full name"
                                autoFocus
                                style={{
                                    width: '100%',
                                    padding: '14px 18px',
                                    background: 'rgba(255, 255, 255, 0.05)',
                                    border: '1px solid rgba(201, 169, 110, 0.3)',
                                    borderRadius: '10px',
                                    color: 'var(--text-light)',
                                    fontSize: '15px',
                                    outline: 'none',
                                    transition: 'all 0.3s ease'
                                }}
                                onFocus={(e) => e.target.style.borderColor = 'var(--accent-color)'}
                                onBlur={(e) => e.target.style.borderColor = 'rgba(201, 169, 110, 0.3)'}
                            />
                        </div>

                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label style={{ 
                                display: 'block', 
                                marginBottom: '6px', 
                                fontSize: '13px', 
                                color: 'rgba(245, 241, 237, 0.9)',
                                fontWeight: '500'
                            }}>
                                Phone Number *
                            </label>
                            <input
                                type="tel"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))}
                                required
                                placeholder="Enter 10-digit mobile number"
                                maxLength="10"
                                style={{
                                    width: '100%',
                                    padding: '14px 18px',
                                    background: 'rgba(255, 255, 255, 0.05)',
                                    border: '1px solid rgba(201, 169, 110, 0.3)',
                                    borderRadius: '10px',
                                    color: 'var(--text-light)',
                                    fontSize: '15px',
                                    outline: 'none',
                                    transition: 'all 0.3s ease'
                                }}
                                onFocus={(e) => e.target.style.borderColor = 'var(--accent-color)'}
                                onBlur={(e) => e.target.style.borderColor = 'rgba(201, 169, 110, 0.3)'}
                            />
                        </div>

                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label style={{ 
                                display: 'block', 
                                marginBottom: '6px', 
                                fontSize: '13px', 
                                color: 'rgba(245, 241, 237, 0.9)',
                                fontWeight: '500'
                            }}>
                                Email Address *
                            </label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder="your.email@example.com"
                                style={{
                                    width: '100%',
                                    padding: '14px 18px',
                                    background: 'rgba(255, 255, 255, 0.05)',
                                    border: '1px solid rgba(201, 169, 110, 0.3)',
                                    borderRadius: '10px',
                                    color: 'var(--text-light)',
                                    fontSize: '15px',
                                    outline: 'none',
                                    transition: 'all 0.3s ease'
                                }}
                                onFocus={(e) => e.target.style.borderColor = 'var(--accent-color)'}
                                onBlur={(e) => e.target.style.borderColor = 'rgba(201, 169, 110, 0.3)'}
                            />
                        </div>

                        <div style={{ 
                            padding: '14px 18px',
                            background: 'rgba(201, 169, 110, 0.05)',
                            border: '1px solid rgba(201, 169, 110, 0.2)',
                            borderRadius: '10px',
                            marginBottom: '20px'
                        }}>
                            <p style={{ 
                                fontSize: '12px', 
                                color: 'rgba(245, 241, 237, 0.8)', 
                                lineHeight: '1.5',
                                textAlign: 'center',
                                margin: 0
                            }}>
                                We'll send a <strong style={{ color: 'var(--accent-color)' }}>6-digit OTP</strong> to verify secure access to this exclusive catalogue.
                            </p>
                        </div>

                        <button 
                            type="submit" 
                            className="btn" 
                            style={{ 
                                width: '100%',
                                background: 'linear-gradient(135deg, #C9A96E 0%, #B8935A 100%)',
                                border: 'none',
                                padding: '16px',
                                fontSize: '16px',
                                fontWeight: '600',
                                borderRadius: '12px',
                                cursor: loading ? 'not-allowed' : 'pointer',
                                opacity: loading ? 0.7 : 1,
                                transition: 'all 0.3s ease',
                                boxShadow: '0 4px 15px rgba(201, 169, 110, 0.3)',
                                color: '#000',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px'
                            }}
                            disabled={loading}
                            onMouseEnter={(e) => !loading && (e.target.style.transform = 'translateY(-2px)', e.target.style.boxShadow = '0 6px 20px rgba(201, 169, 110, 0.4)')}
                            onMouseLeave={(e) => (e.target.style.transform = 'translateY(0)', e.target.style.boxShadow = '0 4px 15px rgba(201, 169, 110, 0.3)')}
                        >
                            {loading ? renderIcon('clock', 20) : renderIcon('send', 20)} {loading ? 'Sending OTP...' : 'Send OTP'}
                        </button>
                    </form>
                )}

                {/* OTP Step */}
                {step === 'otp' && (
                    <form onSubmit={handleVerifyOTP}>
                        <p style={{ 
                            fontSize: '14px', 
                            color: 'rgba(245, 241, 237, 0.8)', 
                            marginBottom: '20px',
                            textAlign: 'center'
                        }}>
                            Enter the 6-digit OTP sent to<br />
                            <strong style={{ color: 'var(--accent-color)' }}>{email}</strong>
                        </p>

                        <div className="form-group">
                            <input
                                type="text"
                                value={otp}
                                onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                                required
                                placeholder="000000"
                                maxLength="6"
                                style={{ 
                                    fontSize: '24px', 
                                    textAlign: 'center',
                                    letterSpacing: '8px',
                                    fontWeight: '600'
                                }}
                                autoFocus
                            />
                        </div>

                        <p style={{ 
                            fontSize: '12px', 
                            color: 'rgba(245, 241, 237, 0.6)', 
                            marginBottom: '20px',
                            textAlign: 'center',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '6px'
                        }}>
                            {renderIcon('clock', 16)} OTP is valid for 10 minutes
                        </p>

                        <button 
                            type="submit" 
                            className="btn" 
                            style={{ 
                                width: '100%', 
                                marginBottom: '20px',
                                background: 'linear-gradient(135deg, #C9A96E 0%, #B8935A 100%)',
                                border: 'none',
                                padding: '16px',
                                fontSize: '16px',
                                fontWeight: '600',
                                borderRadius: '12px',
                                cursor: (loading || otp.length !== 6) ? 'not-allowed' : 'pointer',
                                opacity: (loading || otp.length !== 6) ? 0.5 : 1,
                                transition: 'all 0.3s ease',
                                boxShadow: '0 4px 15px rgba(201, 169, 110, 0.3)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px',
                                color: '#000'
                            }}
                            disabled={loading || otp.length !== 6}
                            onMouseEnter={(e) => (otp.length === 6 && !loading) && (e.target.style.transform = 'translateY(-2px)', e.target.style.boxShadow = '0 6px 20px rgba(201, 169, 110, 0.4)')}
                            onMouseLeave={(e) => (e.target.style.transform = 'translateY(0)', e.target.style.boxShadow = '0 4px 15px rgba(201, 169, 110, 0.3)')}
                        >
                            {loading ? renderIcon('refresh', 20) : renderIcon('check', 20)} {loading ? 'Verifying...' : 'Verify & View Catalogue'}
                        </button>

                        <div style={{ 
                            textAlign: 'center',
                            padding: '15px',
                            background: 'rgba(255, 255, 255, 0.02)',
                            borderRadius: '10px'
                        }}>
                            <button
                                type="button"
                                onClick={() => setStep('details')}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: 'rgba(245, 241, 237, 0.7)',
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                    marginRight: '25px',
                                    transition: 'color 0.3s ease'
                                }}
                                onMouseEnter={(e) => e.target.style.color = 'var(--accent-color)'}
                                onMouseLeave={(e) => e.target.style.color = 'rgba(245, 241, 237, 0.7)'}
                            >
                                ← Change Details
                            </button>
                            <button
                                type="button"
                                onClick={handleResendOTP}
                                disabled={loading}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: 'var(--accent-color)',
                                    fontSize: '14px',
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                    opacity: loading ? 0.5 : 1,
                                    transition: 'all 0.3s ease',
                                    fontWeight: '500',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '4px'
                                }}
                                onMouseEnter={(e) => !loading && (e.target.style.textDecoration = 'underline')}
                                onMouseLeave={(e) => (e.target.style.textDecoration = 'none')}
                            >
                                {renderIcon('refresh', 16)} Resend OTP
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

export default CatalogueOTPModal;

